import {
  Dot,
  DotsContainer
} from 'components/AugmentedReality/Structure/SlideDots/styled'

interface SlideDotsProps {
  count: number;
  currentIndex: number;
  onChangeSlide: (id: number) => void;
}
const SlideDots = ({ count, currentIndex, onChangeSlide }: SlideDotsProps) => {

  return (
    <DotsContainer>
      {Array.from({ length: count }).map((_, index) => (
        <Dot key={index} $active={index === currentIndex} onClick={() => onChangeSlide(index)}>
          {index === currentIndex ? index + 1 : ''}
        </Dot>
      ))}
    </DotsContainer>
  );
};

export default SlideDots;
